var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.219,
    height: 14.502,
    viewBox: "0 0 15.219 14.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44588",
    "data-name": "Path 44588",
    d: "M7.546,0a.577.577,0,0,1,.591.355C8.781,1.67,9.432,2.981,10.075,4.3a.278.278,0,0,0,.246.176c1.454.2,2.907.419,4.361.63a.552.552,0,0,1,.319.99q-1.59,1.544-3.174,3.094a.223.223,0,0,0-.081.228c.257,1.474.505,2.95.759,4.425a.542.542,0,0,1-.808.585q-1.965-1.034-3.93-2.069a.285.285,0,0,0-.306,0c-1.3.69-2.609,1.374-3.914,2.061a.545.545,0,0,1-.627-.017.523.523,0,0,1-.2-.578c.025-.108.034-.22.053-.33.235-1.371.472-2.741.7-4.113a.267.267,0,0,0-.087-.19Q1.806,7.631.219,6.084A.755.755,0,0,1,.027,5.8a.511.511,0,0,1,.4-.669c.5-.089,1-.155,1.5-.228,1.013-.147,2.027-.291,3.039-.445A.29.29,0,0,0,5.135,4.3Q5.976,2.614,6.808.921c.1-.2.2-.409.3-.614A.5.5,0,0,1,7.546,0",
    transform: "translate(0 -0.001)",
    fill: "#ef7b13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/orange_star.a6147a505a18811c39116d77dda45770.svg";
export { ForwardRef as ReactComponent };